const navigateTo = (url: string, targetNewPage: boolean = false) => {
    (!!url ? window.open(url, targetNewPage ? '_blanck' : '_self') : null)
};

export default navigateTo;